import { Injectable } from '@angular/core';

import { BaseService } from './global-support-base.service';
import { IGlobalSupport, ITimeZone, ITimeZoneDropDown } from './global-support.interface';
import { EnterpriseProductivityFeatureFlagService } from '@services/feature-flags/enterprise-productivity';
import { ServerApi } from '../server-api';

import { OLD_TO_STANDARD_TIMEZONE_MAPPER } from './global-support.const';

@Injectable({
  providedIn: 'root',
})
export class GlobalSupportTimezonesService extends BaseService {
  standardTimeZones: ITimeZone[] = [];
  standardTimeZonesMapper: Record<string, ITimeZone> = {};
  timeZoneList: ITimeZoneDropDown[] = [];
  timeZoneMinAppVersion: number;

  constructor(api: ServerApi,
    private epFeatureFlag: EnterpriseProductivityFeatureFlagService,
  ) {
    super(api);
    this.timeZoneCountryData$.subscribe(data => {
      this.standardTimeZones = this.getTimeZones(data);
      this.timeZoneMinAppVersion = data.minAppVersion;
      this.standardTimezonesMapperInit();
    });
  }

  public get standardTimeZonesIdentifiers(): string[] {
    return this.standardTimeZones.map(timezone => timezone.ianaIdentifier);
  }

  public getStandardTimeZoneLabel(timeZoneLabel: string): string {
    return this.standardTimeZonesMapper[timeZoneLabel].standardName || timeZoneLabel;
  }

  public isNewTimeZone(oldTimezoneLabel: string): boolean {
    return OLD_TO_STANDARD_TIMEZONE_MAPPER[oldTimezoneLabel] === undefined;
  }

  public getNewTimeZoneMinAppVersion(): number {
    return this.timeZoneMinAppVersion;
  }

  public getIANAIdentifier(timeZoneLabel: string): string {
    return this.standardTimeZonesMapper[timeZoneLabel]?.ianaIdentifier || timeZoneLabel;
  }

  private getTimeZones(data: IGlobalSupport): ITimeZone[] {
    return data ? data.timeZones : null;
  }

  private standardTimezonesMapperInit(): void {
    this.timeZoneList = [];
    this.standardTimeZones.forEach(timezone => {
      this.standardTimeZonesMapper[timezone.backendTimeZone] = timezone;
      this.timeZoneList.push({
        value: timezone.backendTimeZone,
        label: timezone.localizedStandardNameWithGMTOffset,
      });
    });
  }

}